// extracted by mini-css-extract-plugin
export var gridContainer = "styles-module--gridContainer--78278";
export var spinner = "styles-module--spinner--600f2";
export var spinnerContainer = "styles-module--spinnerContainer--4108a";